import { houseData } from "../actionTypes"

export const loadHouse = (id,data)=>{

  return{
    type:houseData.ADD,
    payload:{id:id,house:data}
  }
}

export const updateHouse = (houseId,roomId,data)=>{

  return{
    type:houseData.UPDATE,
    payload:{houseId,roomId,devices:data}
  }
}